import _objectWithoutProperties from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["children", "labelPosition", "labelAlign", "isRequired", "necessityIndicator", "isQuiet", "isEmphasized", "isDisabled", "isReadOnly", "validationState"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "./main.css";
import { useStyleProps as $011V3$useStyleProps, useDOMRef as $011V3$useDOMRef, classNames as $011V3$classNames } from "@react-spectrum/utils";
import { filterDOMProps as $011V3$filterDOMProps } from "@react-aria/utils";
import { useProviderProps as $011V3$useProviderProps, Provider as $011V3$Provider } from "@react-spectrum/provider";
import $011V3$react, { useContext as $011V3$useContext } from "react";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
var $cd231e464c886c86$exports = {};
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel", function () {
  return $cd231e464c886c86$export$493d18e796ae054;
}, function (v) {
  return $cd231e464c886c86$export$493d18e796ae054 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel--positionSide", function () {
  return $cd231e464c886c86$export$9e6f19dc21f22f2e;
}, function (v) {
  return $cd231e464c886c86$export$9e6f19dc21f22f2e = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel-requiredIcon", function () {
  return $cd231e464c886c86$export$7c47642c7d46f3c9;
}, function (v) {
  return $cd231e464c886c86$export$7c47642c7d46f3c9 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-FieldLabel--alignEnd", function () {
  return $cd231e464c886c86$export$885efcc08143a987;
}, function (v) {
  return $cd231e464c886c86$export$885efcc08143a987 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field", function () {
  return $cd231e464c886c86$export$f6d480ae1e56eba0;
}, function (v) {
  return $cd231e464c886c86$export$f6d480ae1e56eba0 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--positionTop", function () {
  return $cd231e464c886c86$export$a4ea780a9064d7f9;
}, function (v) {
  return $cd231e464c886c86$export$a4ea780a9064d7f9 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-field", function () {
  return $cd231e464c886c86$export$3ab8a3dc7f0563d;
}, function (v) {
  return $cd231e464c886c86$export$3ab8a3dc7f0563d = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--alignEnd", function () {
  return $cd231e464c886c86$export$5354c9be7ada5f83;
}, function (v) {
  return $cd231e464c886c86$export$5354c9be7ada5f83 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--positionSide", function () {
  return $cd231e464c886c86$export$2963225c91179589;
}, function (v) {
  return $cd231e464c886c86$export$2963225c91179589 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-wrapper", function () {
  return $cd231e464c886c86$export$127df0b7290eb8ef;
}, function (v) {
  return $cd231e464c886c86$export$127df0b7290eb8ef = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-contextualHelp", function () {
  return $cd231e464c886c86$export$24fb860d16dd2d3f;
}, function (v) {
  return $cd231e464c886c86$export$24fb860d16dd2d3f = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field--hasContextualHelp", function () {
  return $cd231e464c886c86$export$9ba23707a252cdd4;
}, function (v) {
  return $cd231e464c886c86$export$9ba23707a252cdd4 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Form", function () {
  return $cd231e464c886c86$export$94d2bcc94afabd89;
}, function (v) {
  return $cd231e464c886c86$export$94d2bcc94afabd89 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Form--positionSide", function () {
  return $cd231e464c886c86$export$7f44db659563c8f4;
}, function (v) {
  return $cd231e464c886c86$export$7f44db659563c8f4 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-labelCell", function () {
  return $cd231e464c886c86$export$9cde5aecff012641;
}, function (v) {
  return $cd231e464c886c86$export$9cde5aecff012641 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Field-labelWrapper", function () {
  return $cd231e464c886c86$export$a872a8c78b26c9e0;
}, function (v) {
  return $cd231e464c886c86$export$a872a8c78b26c9e0 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Form--positionTop", function () {
  return $cd231e464c886c86$export$11b8bc81fe551057;
}, function (v) {
  return $cd231e464c886c86$export$11b8bc81fe551057 = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-LabeledValue", function () {
  return $cd231e464c886c86$export$79f9a5e9dd010c8d;
}, function (v) {
  return $cd231e464c886c86$export$79f9a5e9dd010c8d = v;
});
$parcel$export($cd231e464c886c86$exports, "spectrum-Form-itemLabel", function () {
  return $cd231e464c886c86$export$51ec27881a1e3928;
}, function (v) {
  return $cd231e464c886c86$export$51ec27881a1e3928 = v;
});
$parcel$export($cd231e464c886c86$exports, "is-disabled", function () {
  return $cd231e464c886c86$export$d35bc1e505d1ebbf;
}, function (v) {
  return $cd231e464c886c86$export$d35bc1e505d1ebbf = v;
});
var $cd231e464c886c86$export$493d18e796ae054;
var $cd231e464c886c86$export$9e6f19dc21f22f2e;
var $cd231e464c886c86$export$7c47642c7d46f3c9;
var $cd231e464c886c86$export$885efcc08143a987;
var $cd231e464c886c86$export$f6d480ae1e56eba0;
var $cd231e464c886c86$export$a4ea780a9064d7f9;
var $cd231e464c886c86$export$3ab8a3dc7f0563d;
var $cd231e464c886c86$export$5354c9be7ada5f83;
var $cd231e464c886c86$export$2963225c91179589;
var $cd231e464c886c86$export$127df0b7290eb8ef;
var $cd231e464c886c86$export$24fb860d16dd2d3f;
var $cd231e464c886c86$export$9ba23707a252cdd4;
var $cd231e464c886c86$export$94d2bcc94afabd89;
var $cd231e464c886c86$export$7f44db659563c8f4;
var $cd231e464c886c86$export$9cde5aecff012641;
var $cd231e464c886c86$export$a872a8c78b26c9e0;
var $cd231e464c886c86$export$11b8bc81fe551057;
var $cd231e464c886c86$export$79f9a5e9dd010c8d;
var $cd231e464c886c86$export$51ec27881a1e3928;
var $cd231e464c886c86$export$d35bc1e505d1ebbf;
$cd231e464c886c86$export$493d18e796ae054 = "spectrum-FieldLabel_d2db1f";
$cd231e464c886c86$export$9e6f19dc21f22f2e = "spectrum-FieldLabel--positionSide_d2db1f";
$cd231e464c886c86$export$7c47642c7d46f3c9 = "spectrum-FieldLabel-requiredIcon_d2db1f";
$cd231e464c886c86$export$885efcc08143a987 = "spectrum-FieldLabel--alignEnd_d2db1f";
$cd231e464c886c86$export$f6d480ae1e56eba0 = "spectrum-Field_d2db1f";
$cd231e464c886c86$export$a4ea780a9064d7f9 = "spectrum-Field--positionTop_d2db1f";
$cd231e464c886c86$export$3ab8a3dc7f0563d = "spectrum-Field-field_d2db1f";
$cd231e464c886c86$export$5354c9be7ada5f83 = "spectrum-Field--alignEnd_d2db1f";
$cd231e464c886c86$export$2963225c91179589 = "spectrum-Field--positionSide_d2db1f";
$cd231e464c886c86$export$127df0b7290eb8ef = "spectrum-Field-wrapper_d2db1f";
$cd231e464c886c86$export$24fb860d16dd2d3f = "spectrum-Field-contextualHelp_d2db1f";
$cd231e464c886c86$export$9ba23707a252cdd4 = "spectrum-Field--hasContextualHelp_d2db1f";
$cd231e464c886c86$export$94d2bcc94afabd89 = "spectrum-Form_d2db1f";
$cd231e464c886c86$export$7f44db659563c8f4 = "spectrum-Form--positionSide_d2db1f";
$cd231e464c886c86$export$9cde5aecff012641 = "spectrum-Field-labelCell_d2db1f";
$cd231e464c886c86$export$a872a8c78b26c9e0 = "spectrum-Field-labelWrapper_d2db1f";
$cd231e464c886c86$export$11b8bc81fe551057 = "spectrum-Form--positionTop_d2db1f";
$cd231e464c886c86$export$79f9a5e9dd010c8d = "spectrum-LabeledValue_d2db1f";
$cd231e464c886c86$export$51ec27881a1e3928 = "spectrum-Form-itemLabel_d2db1f";
$cd231e464c886c86$export$d35bc1e505d1ebbf = "is-disabled_d2db1f";
var $ac118ceca79b8650$var$FormContext = /*#__PURE__*/$011V3$react.createContext(null);
function $ac118ceca79b8650$export$a6b5be5c6b451665(props) {
  var ctx = $011V3$useContext($ac118ceca79b8650$var$FormContext);
  if (ctx) return _objectSpread(_objectSpread({}, ctx), props);
  return props;
}
var $ac118ceca79b8650$var$formPropNames = new Set(['action', 'autoComplete', 'encType', 'method', 'target', 'onSubmit']);
function $ac118ceca79b8650$var$Form(props, ref) {
  props = $011V3$useProviderProps(props);
  var _props = props,
    children = _props.children,
    _props$labelPosition = _props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? 'top' : _props$labelPosition,
    _props$labelAlign = _props.labelAlign,
    labelAlign = _props$labelAlign === void 0 ? 'start' : _props$labelAlign,
    isRequired = _props.isRequired,
    necessityIndicator = _props.necessityIndicator,
    isQuiet = _props.isQuiet,
    isEmphasized = _props.isEmphasized,
    isDisabled = _props.isDisabled,
    isReadOnly = _props.isReadOnly,
    validationState = _props.validationState,
    otherProps = _objectWithoutProperties(_props, _excluded);
  var _$011V3$useStyleProps = $011V3$useStyleProps(otherProps),
    styleProps = _$011V3$useStyleProps.styleProps;
  var domRef = $011V3$useDOMRef(ref);
  var ctx = {
    labelPosition: labelPosition,
    labelAlign: labelAlign,
    necessityIndicator: necessityIndicator
  };
  return /*#__PURE__*/$011V3$react.createElement("form", _objectSpread(_objectSpread(_objectSpread({}, $011V3$filterDOMProps(otherProps, {
    labelable: true,
    propNames: $ac118ceca79b8650$var$formPropNames
  })), styleProps), {}, {
    noValidate: true,
    ref: domRef,
    className: $011V3$classNames( /*@__PURE__*/$parcel$interopDefault($cd231e464c886c86$exports), 'spectrum-Form', {
      'spectrum-Form--positionSide': labelPosition === 'side',
      'spectrum-Form--positionTop': labelPosition === 'top'
    }, styleProps.className)
  }), /*#__PURE__*/$011V3$react.createElement($ac118ceca79b8650$var$FormContext.Provider, {
    value: ctx
  }, /*#__PURE__*/$011V3$react.createElement($011V3$Provider, {
    isQuiet: isQuiet,
    isEmphasized: isEmphasized,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired,
    validationState: validationState
  }, children)));
}
/**
 * Forms allow users to enter data that can be submitted while providing alignment and styling for form fields.
 */
var $ac118ceca79b8650$export$a7fed597f4b8afd8 = /*#__PURE__*/$011V3$react.forwardRef($ac118ceca79b8650$var$Form);
export { $ac118ceca79b8650$export$a6b5be5c6b451665 as useFormProps, $ac118ceca79b8650$export$a7fed597f4b8afd8 as Form };